import { AsyncAction } from 'shared/types/utilities';

import jobService from 'services/api/job/jobService';

import { IApplicationState } from '..';

import { ReportConcern } from './job.types';

export const reportConcern: AsyncAction<ReportConcern, IApplicationState> = (data) => async () =>
  jobService.reportConcern(data);
